<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row p-3">
        <div class="col-md-5">
          <div class="form-group">
            <label for="" class="form-label">Search Accomodation</label>
            <input type="text" class="form-control" placeholder="Search Accomodation" v-model="searchAccomodaiton">
          </div>
        </div>
        <div class="col-md-3">
          <button class="button button--small" @click="getAccommodation" style="margin-top: 30px;">Search</button>
          <button class="button button--small" @click="clearAccomodationSearch" style="margin-top: 30px;" v-if="searchAccomodaiton">Clear</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <table class="table" cellspacing="0" cellpadding="0">
            <thead>
              <tr>
                <th>Accommodation</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-if="accommodations.length > 0">
                <template v-for="accommodation of accommodations">
                  <tr :key="accommodation.id + '-accommodation'">
                    <td>{{ accommodation.accommodation_name }}</td>
                    <td class="table-action"><button v-on:click="expandedAccommodation = accommodation.id">Expand</button></td>
                  </tr>
                  <tr :key="accommodation.id + '-accommodation-expand'" v-if="expandedAccommodation == accommodation.id">
                    <td colspan="3">
                      <table class="table" cellspacing="0" cellpadding="0">
                        <thead>
                          <tr>
                            <th>Room</th>
                            <th>Board basis</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="room of accommodation.accommodation_rooms" :key="room.id">
                            <td>{{ room.name }}</td>
                            <td>{{ room.board_basis }}</td>
                            <td class="table-action">
                              <template v-if="type === 'tour-group'">
                                <template v-if="room.is_multiple">
                                  <select v-on:change="emitAccommodation(room, accommodation, $event.target.value)">
                                    <option value="">Select</option>
                                    <option v-for="n in room.multiple_rooms_description" :key="n.id" :value="n.description">{{ n.description }}</option>
                                  </select>
                                </template>
                                <template v-else>
                                  <button class="button button--small" @click="emitAccommodation(room, accommodation)">Select</button>
                                </template>
                              </template>
                              <template v-if="type === 'booking'">
                                <template v-if="room.is_multiple">
                                  <select v-on:change="selectAccommodation(room, $event.target.value)">
                                    <option value="">Select</option>
                                    <option v-for="n in room.multiple_rooms_description" :key="n.id" :value="n.description">{{ n.description }}</option>
                                  </select>
                                </template>
                                <template v-else>
                                  <button class="button button--small booking" @click="selectAccommodation(room)">Select</button>
                                </template>
                              </template>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </template>
              </template>
              <template v-else>
                <tr>
                  <td colspan="2" class="text-center">No Accommodation Found</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props : {
    tour_booking: Object,
    type: {
      default: 'booking',
      type: String
    }
  },
  data() {
    return  {
      accommodations: [],
      expandedAccommodation: null,
      searchAccomodaiton:''
    }
  },
  mounted() {
    this.getAccommodation();
  },
  methods: {
    getAccommodation() {
      this.$store.dispatch("setLoadStatus");
      let url = `${this.$api}accommodation`
      if (this.searchAccomodaiton) {
        url+=`?filter_by_name=${this.searchAccomodaiton}`
      }
      fetch(url, {
        headers: {
          Accept: "application/json",
          Authorization: localStorage.getItem("token")
        }
      })
        .then(res => res.json())
        .then(response => {
          this.$store.dispatch("setLoadStatus");
          this.accommodations = response.data;
        });
    },
    selectAccommodation(room,  selectedValue=null) {
      this.$dialog
      .confirm('Are you sure you want to update the accommodation?')
      .then(() => {
        const accommodationRequest = {
          tour_booking_id: this.tour_booking.id,
          room_id: room.id,
          accommodation_id: room.accommodation_id,
          selected_multiple_room: selectedValue
        };
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'bookings/tour-booking/update-accommodation', {
          method: 'POST',
          body: JSON.stringify(accommodationRequest),
          headers:{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        })
        .then(res => res.json())
        .then(response => {
          if(response.success) {
            this.$notify({
              type: 'success',
              title: response.message
            });
            this.$emit('sync-booking');
            this.$parent.showAccommodationList = false;
          } else if (response.errors) {
            this.$notify({
              type: 'error',
              title: response.message
            });
          }
          this.$store.dispatch('setLoadStatus')
        });
      })
      .catch(() => {
        console.log('Clicked on cancel');
      });
    },
    emitAccommodation(room, accommodation, room_selected_value=null) {
      this.$emit('accommodation-select', room, accommodation, room_selected_value);
    },
    clearAccomodationSearch() {
      if (this.searchAccomodaiton) {
        this.searchAccomodaiton = ''
        this.getAccommodation()
      }
    }
  }
};
</script>
